export enum OrganismeFormeJuridique {
  EI = 'EI', // Entreprise individuelle
  EURL = 'EURL', // Entreprise unipersonnelle à responsabilité limitée
  SARL = 'SARL', // Société à responsabilité limitée
  SA = 'SA', // Société anonyme
  SAS = 'SAS', // Société par actions simplifiée
  SASU = 'SASU', // Société par actions simplifiée unipersonnelle
  SNC = 'SNC', // Société en nom collectif
  SCOP = 'SCOP', // Société coopérative de production
  ASSOCIATION = 'ASSOCIATION', // Association
  CONSULAIRE = 'CONSULAIRE', // Consulaire
  STRUCTPUB = 'STRUCTPUB', // Structure publique
  AUTRE = 'AUTRE', // Autre structure privée
}